import { render } from "./QuickAddChild.vue?vue&type=template&id=6c209bbb&scoped=true"
import script from "./QuickAddChild.vue?vue&type=script&lang=js"
export * from "./QuickAddChild.vue?vue&type=script&lang=js"

import "./QuickAddChild.vue?vue&type=style&index=0&id=6c209bbb&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c209bbb"]])

export default __exports__